var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70719 2.29151C3.31671 1.90094 2.68355 1.90087 2.29298 2.29134C1.90241 2.68182 1.90233 3.31499 2.29281 3.70556L6.58693 8.0007L2.29425 12.2944C1.90377 12.685 1.90385 13.3181 2.29442 13.7086C2.68499 14.0991 3.31815 14.099 3.70863 13.7085L8.00098 9.41509L12.2933 13.7085C12.6838 14.099 13.317 14.0991 13.7075 13.7086C14.0981 13.3181 14.0982 12.685 13.7077 12.2944L9.41502 8.0007L13.7091 3.70556C14.0996 3.31499 14.0995 2.68182 13.709 2.29134C13.3184 1.90087 12.6852 1.90094 12.2948 2.29151L8.00098 6.58632L3.70719 2.29151Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMark);
export default __webpack_public_path__ + "static/media/close_mark.b18ab9cf6c2889b11e7213fbfd9a49f5.svg";
export { ForwardRef as ReactComponent };